import { Link } from 'react-router-dom';

import LinkIcon from '~/shared/assets/icons/link.svg';
import Typography from '~/shared/components/Typography';
import { buildVolumePageUrl } from '~/fleet-manager/components/FleetManagerPage/helpers';

export default function VolumeIdCell({ id, accountId }: { id: string; accountId?: string }) {
  return (
    <Link
      to={buildVolumePageUrl(id, accountId)}
      className="flex min-w-0 max-w-full w-full items-center gap-1 overflow-hidden pr-2"
      title={id}
    >
      <Typography
        color="text-primary-500"
        variant="p3"
        fontWeight={700}
        truncate
        className="min-w-0 flex-1 font-family-inter cursor-pointer"
      >
        {id}
      </Typography>
      <LinkIcon className="size-5 shrink-0" />
    </Link>
  );
}
